"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isBrowser = _interopRequireDefault(require("./isBrowser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getURLSearchParams() {
  var _window;
  if (!(0, _isBrowser.default)()) return;
  const queryString = (_window = window) === null || _window === void 0 ? void 0 : _window.location.search;
  return new URLSearchParams(queryString);
}
var _default = exports.default = getURLSearchParams;